import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'public/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MemberSubscrpitionHistoryService {

  constructor(private http: HttpClient) { }

  getMemberSubscriptionHistoriesForMemberUser(): any {
    return this.http.get(`${environment.apiUrl}/MemberSubscrpitionHistory/GetMemberSubscriptionHistoriesForMemberUser`);
  }
  reNewSubscription(model: any): any {
    return this.http.post(`${environment.apiUrl}/MemberSubscrpitionHistory/ReNewSubscription`, model);
  }
}
